import Styles from "./JsonDisplay.module.scss"

interface Props {
    jsonObj: object
    replacer?: (key: string, value: unknown) => unknown
}
export function JsonDisplay({jsonObj, replacer}: Props) {
    return <pre className={Styles.JsonDisplay}>{JSON.stringify(jsonObj, replacer, 2)}</pre>
}